/************************************************************************
10/25/17
All Actions for map interactions
************************************************************************/
import { FETCH_FIELD_INFORMATION, SET_MAP_VIEW, SET_FIELD_VIEW, SET_MAP_LOCATION
} from './types';
import { error } from './index';
import { ROOT_URL } from '../constants';
import axios from 'axios';
const $ = window.$;
/* Fetch field information: called in containers/main.js  */
export function fetchFieldInfo(field) {
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchFieldInfo`,{
      params: { field },
      headers: { authorization: localStorage.getItem('token') }
    }).then((response) => JSON.parse(response.request.response))
      .then((res) => {
        $('#preloader').css('display','none');
        //console.log(res);
        dispatch({ type: FETCH_FIELD_INFORMATION, payload: res });
      }).catch((err) => dispatch(error(`There was an error fetching field information: ${err}`)));
  }
}

/* Sets the application interface as viewing map, or main app: called in containers/navbar.js */
export function setMapView() {
  return {
    type: SET_MAP_VIEW
  }
}
/* Sets the field the user is hovering over: Called in containers/main.js */
export function setFieldView(field) {
  return {
    type: SET_FIELD_VIEW,
    payload: field
  }
}
/* Switches between locations: Kau & Keaau: Called in containers/navbar.js */
export function setMapLocation(loc) {
  return {
    type: SET_MAP_LOCATION,
    payload: loc
  }
}





































/* END */



// WEBPACK FOOTER //
// ./src/actions/map_actions.js